(function (w, d) {
	var smoothScroll = new SmoothScroll('a[href*="#"]');

	smoothScroll.init();
	if ( w.location.hash ) {
		var anchor = d.querySelector( w.location.hash );
		var toggle = d.querySelector( 'a[href*="' + w.location.hash + '"]' );
		var options = {
			callback: function (anchor, toggle){
				header.toggleMenu(toggle);
			}
		};
		smoothScroll.animateScroll( anchor, toggle, options );
	}

	gumshoe.init({
		selector: '[data-gumshoe] a',
		selectorHeader: '[data-gumshoe-header]',
		container: w,
		offset: 0,
		activeClass: 'is-active',
		callback: function (nav) {}
	});

	var Header = function Header(context) {
		this.html = context.documentElement;
		this.header = context.querySelector("#header");
		this.stuck = false;
		this.stickPoint = this.getDistance();
		this.nav = context.querySelector('.nav');
		this.navMenu = this.nav.querySelector('.nav-menu');
		this.navItem = this.navMenu.querySelectorAll('.nav-item');
		this.navToggle = this.nav.querySelector('.nav-toggle');
	};

	Header.prototype.getDistance = function getDistance() {
		return this.header.offsetTop;
	};

	Header.prototype.setFixed = function setFixed() {
		var distance = this.getDistance() - w.pageYOffset;
		var offset = w.pageYOffset;

		if ( (distance <= 0) && !this.stuck) {
			this.header.classList.add('is-scrolled');
			this.stuck = true;
		} else if (this.stuck && (offset <= this.stickPoint)) {
			this.header.classList.remove('is-scrolled');
			this.stuck = false;
		}
	};

	// Togglers
	Header.prototype.toggleMenu = function toggleMenu(link) {
		for (var i = this.navItem.length - 1; i >= 0; i--) {
			this.navItem[i].classList.remove('is-active');
		}
		this.html.classList.contains('is-open') ? this.toggleHeader() : '';
		link.classList.add('is-active');
	};

	Header.prototype.toggleHeader = function toggleHeader() {
		this.html.classList.toggle('is-open');
		this.navMenu.classList.toggle('is-active');
		this.navToggle.classList.toggle('is-active');
	};

	// add event listeners
	var header = new Header(w.document);

	w.addEventListener('scroll', function (e) {
		header.setFixed(e);
	});

	header.navToggle.addEventListener('click', function () {
		header.toggleHeader();
	});

	for (var i = header.navItem.length - 1; i >= 0; i--) {
		header.navItem[i].addEventListener('click', function (){
			header.toggleMenu(this);
		});
	}
	d.addEventListener('click', function(event) {
		if (event.target !== header.nav && !header.nav.contains(event.target)) {
			header.html.classList.remove('is-open');
			header.navMenu.classList.remove("is-active");
			header.navToggle.classList.remove('is-active');
		}
	});

})(window, document);
